import { VERSION } from "../version";

function Footer() {
  return (
    <footer className="py-6 text-center text-xs text-gray-500">
      v{VERSION}
    </footer>
  );
}

export default Footer;
